import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IProiect } from '../../proiecte.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';
import { Observable, finalize, map } from 'rxjs';
import { ICategorieForm, ICategorieUpdatePayload } from './update-categorie-proiect.interface';
import { ProiecteService } from '../../proiecte.service';

@Component({
    selector: 'app-update-categorie-proiect',
    templateUrl: './update-categorie-proiect.component.html',
    styleUrls: ['./update-categorie-proiect.component.scss']
})
export class UpdateCategorieProiectComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    passedProiectId!: number;
    departamenteActive: Generic[] = [];
    sectiuni: Generic[] = [];
    categorii: Generic[] = [];

    categoriiActive$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        section: new FormControl(this.data.proiect.id_sectiune || -1, [Validators.required, Validators.min(0)]),
        category: new FormControl(this.data.proiect.id_categorie || -1, []), // Required?
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            proiect: IProiect,
            departamenteActive: Generic[],
            sectiuni: Generic[],
        },
        private dialogRef: MatDialogRef<UpdateCategorieProiectComponent>,
        private notificationService: NotificationService,
        private commonService: CommonService,
        private proiecteService: ProiecteService,
    ) { }

    ngOnInit(): void {
        this.passedProiectId = this.data.proiect.id_proiect;
        this.departamenteActive = this.data.departamenteActive;
        this.sectiuni = this.data.sectiuni;

        this.loadCategoriiActive(this.data.proiect.id_sectiune);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { category } = this.form.value as ICategorieForm;
        const payload: ICategorieUpdatePayload = {
            category
        };

        this.proiecteService
            .updateCategorie(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onSectiuneChange(sectiuneId: number): void {
        if (sectiuneId > 0) {
            this.loadCategoriiActive(sectiuneId);
        } else {
            this.categoriiActive$ = new Observable<Generic[]>((observer) => {
                observer.next([{ name: '--Alegeți--', id: -1 }]);
                observer.complete();
            });
        }
    }

    loadCategoriiActive(sectiuneId?: number) {
        this.isLoading = true;
        let categoriiObservable$ = sectiuneId
            ? this.commonService.filterCategoriiProiecte(sectiuneId)
            : this.commonService.getCategoriiProiecte();

        this.categoriiActive$ = categoriiObservable$.pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => {
                this.isLoading = false;
            })
        );
    }
}
